import React from 'react';
import PropTypes from 'prop-types';
import BackupListContainer from 'components/BackupList/BackupListContainer';

const propTypes = {
  service: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  backups: PropTypes.instanceOf(Array),
  pitrBackupInfo: PropTypes.shape({
    message: PropTypes.string,
    lastSnapshotTimeStamp: PropTypes.string,
    lastPitrChunkTimeStamp: PropTypes.string,
    state: PropTypes.number,
    status: PropTypes.string,
  }),
};

const defaultProps = {
  backups: [],
  pitrBackupInfo: {},
};

export function UnstyledBackupsTab({ service, id, backups, pitrBackupInfo }) {
  return (
    <BackupListContainer
      backups={backups}
      instanceService={service}
      instanceId={id}
      pitrBackupInfo={pitrBackupInfo}
    />
  );
}

UnstyledBackupsTab.propTypes = propTypes;
UnstyledBackupsTab.defaultProps = defaultProps;

export default UnstyledBackupsTab;
